import Navbar from "./components/layout/Navbar"
import Footer from "./components/layout/Footer"

import WhatsAppButton from "./components/common/WhatsAppButton"

import AppRoutes from "./routes/AppRoutes"
import ScrollToTop from "./components/common/ScrollToTop"
export default function App() {
return (
<div className="min-h-screen flex flex-col bg-white">
      <ScrollToTop />
{/* Navigation */}  
  <Navbar />  

  {/* Contenu principal */}  
  <main className="flex-1">  
    <AppRoutes />  
  </main>  

  {/* Pied de page */}  
  <Footer />  

  {/* Bouton WhatsApp flottant */}  
  <WhatsAppButton />  

</div>

)
}